import { supabase } from '@/integrations/supabase/client';

export interface OSConsumerItem {
  os_id: string;
  numero_os: string;
  empresa: { id: string; nome: string; logo_url: string | null };
  servicos: string[];
  status: string | null;
  data_agendada: string | null;
  data_fim_execucao: string | null;
  valor_total: number | null;
  ja_avaliada: boolean;
}

export interface OSConsumerDetalhe {
  os_id: string;
  numero_os: string;
  empresa: { id: string; nome: string; logo_url: string | null };
  status: string | null;
  data_agendada: string | null;
  data_inicio_execucao: string | null;
  data_fim_execucao: string | null;
  valor_total: number | null;
  endereco: unknown;
  fotos_servico: unknown;
  observacoes: string | null;
  servicos: string[];
  avaliacao: { nota: number; comentario: string | null; criado_em: string | null } | null;
}

export interface AvaliarOSInput { osId: string; nota: number; comentario?: string }

/** Lista as OS do cliente cross-empresa (RPC). */
export async function listarOSConsumer(): Promise<OSConsumerItem[]> {
  const { data, error } = await supabase.rpc('listar_os_consumer');
  if (error) throw error;
  return (data as unknown as OSConsumerItem[]) ?? [];
}

/** Detalhe read-only de uma OS do cliente, ou null se não for dele. */
export async function obterOSConsumer(osId: string): Promise<OSConsumerDetalhe | null> {
  const { data, error } = await supabase.rpc('obter_os_consumer', { p_os_id: osId });
  if (error) throw error;
  return (data as unknown as OSConsumerDetalhe) ?? null;
}

/** Avalia uma OS concluída do cliente (1-5 + comentário). */
export async function avaliarOSConsumer(input: AvaliarOSInput): Promise<string> {
  const { data, error } = await supabase.rpc('avaliar_os_consumer', {
    p_os_id: input.osId,
    p_nota: input.nota,
    p_comentario: input.comentario ?? '',
  });
  if (error) throw error;
  return data as string;
}
